import { render, staticRenderFns } from "./SimulationCard.vue?vue&type=template&id=ed180f92&"
import script from "./SimulationCard.vue?vue&type=script&lang=js&"
export * from "./SimulationCard.vue?vue&type=script&lang=js&"
import style0 from "./SimulationCard.vue?vue&type=style&index=0&id=ed180f92&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports